import { z } from "zod";
import { TypePays } from "../enums/type-pays.enum";

export const coordonneesFormSchema = z
  .object({
    civiliteId: z.string(),
    nom: z.string().min(1, "Requis"),
    prenom: z.string().min(1, "Requis"),
    dateDeNaissance: z.string().optional(),
    adresse1: z.string().min(1, "Requis"),
    adresse2: z.string(),
    codePostal: z.string().min(1, "Requis"),
    ville: z.string().min(1, "Requis"),
    telephone: z.string().min(1, "Requis"),
    typePays: z.nativeEnum(TypePays),
    pays: z.string(),
    raisonSociale: z.string(),
    personneMorale: z.boolean(),
    envoyerAdresseDifferente: z.boolean(),
    nomLivraison: z.string(),
    entrepriseLivraison: z.string(),
    adresse1Livraison: z.string(),
    adresse2Livraison: z.string(),
    codePostalLivraison: z.string(),
    villeLivraison: z.string(),
    paysLivraison: z.string(),
    typePaysLivraison: z.nativeEnum(TypePays),
    siret: z.string(),
    noTva: z.string(),
  })
  .superRefine((data, ctx) => {
    if (data.envoyerAdresseDifferente && !data.nomLivraison && !data.entrepriseLivraison) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Nom ou entreprise de livraison requis",
        path: ["entrepriseLivraison"],
      });
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Nom ou entreprise de livraison requis",
        path: ["nomLivraison"],
      });
    }

    if (!data.personneMorale && !data.dateDeNaissance) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Requis",
        path: ["dateDeNaissance"],
      });
    }
    if (!data.personneMorale && !data.civiliteId) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Requis",
        path: ["civiliteId"],
      });
    }
    if (data.personneMorale && !data.raisonSociale) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Requis",
        path: ["raisonSociale"],
      });
    }
  });
